import { render } from "./S610_TreuhandTeilnehmerListe.vue?vue&type=template&id=1106ab38&scoped=true&ts=true"
import script from "./S610_TreuhandTeilnehmerListe.vue?vue&type=script&lang=ts"
export * from "./S610_TreuhandTeilnehmerListe.vue?vue&type=script&lang=ts"

import "./S610_TreuhandTeilnehmerListe.vue?vue&type=style&index=0&id=1106ab38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1106ab38"]])

export default __exports__